import {css} from '@emotion/react';
import './global.css';
import '../../packages/semantic/dist/semantic.min.css';

export default css``;
